import { validatorFactory } from '../containers/App/validators';

export const normalizeEmail = (email) =>
  email ? email.toLowerCase().replace(/\s/g, '') : '';

export const isInvalidEmail = (email) =>
  validatorFactory({
    email: {
      required: true,
      regex: {
        pattern:
          "^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\\.?[-!#$%&'*+/0-9=?A-Z^_a-z{|}~])*@[a-z0-9](-?[a-z0-9])*(\\.[a-z](-?[a-z0-9])*)+$",
        modifier: 'i',
      },
    },
  }).email(email, {});
